import { render, staticRenderFns } from "./MapTripSearchSelectedTruck.vue?vue&type=template&id=2c3b9e55&scoped=true&"
import script from "./MapTripSearchSelectedTruck.vue?vue&type=script&lang=js&"
export * from "./MapTripSearchSelectedTruck.vue?vue&type=script&lang=js&"
import style0 from "./MapTripSearchSelectedTruck.vue?vue&type=style&index=0&id=2c3b9e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b9e55",
  null
  
)

/* custom blocks */
import block0 from "./MapTripSearchSelectedTruck.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports